module.exports = __webpack_public_path__ + "assets/c25a56090c8fb7a1247e9c82cd7be050.png";